import { useEffect, useMemo, useRef } from "react";
import Anchor from "./Anchor";
import FontAwesomeIcon from "../icon/FontAwesomeIcon";
import "./css/Pagination.css";

export default function Pagination({
  page,
  pages,
  onChange,
  className,
  disabled,
  sm,
  ...props
}) {
  const inputRef = useRef();
  const handleChange = useMemo(
    () => (event) => {
      if (event.target === inputRef.current) {
        if (onChange instanceof Function) {
          onChange(event);
        }
      } else {
        event.stopPropagation();
      }
    },
    [onChange],
  );
  const computedClassName = [
    "pagination",
    ...className.split(" "),
    (!!sm && "pagination-sm") || "",
  ]
    .join(" ")
    .trim();
  const handlePageClick = (page) => (event) => {
    event.preventDefault();
    if (page >= 0 && page < pages) {
      inputRef.current.value = page;
      inputRef.current.dispatchEvent(
        new Event("change", {
          bubbles: true,
          cancelable: true,
          composed: false,
        }),
      );
    }
  };
  useEffect(() => {
    const input = inputRef.current;
    const onChange = handleChange;
    if (!!input) {
      input.addEventListener("change", onChange);
      return () => {
        input.removeEventListener("change", onChange);
      };
    }
  }, [handleChange]);
  const showingPages = useMemo(() => Array.apply(null, Array(pages)), [pages]);
  return (
    <ul className={computedClassName} ref={inputRef}>
      <li className={(disabled || page <= 0 || pages === 0) && "disabled"}>
        <Anchor onClick={handlePageClick(0)}>
          <FontAwesomeIcon name="angle-double-left" />
        </Anchor>
      </li>
      <li className={(disabled || page <= 0 || pages === 0) && "disabled"}>
        <Anchor onClick={handlePageClick(page * 1 - 1)}>
          <FontAwesomeIcon name="angle-left" />
        </Anchor>
      </li>
      {showingPages.map((_, index) => {
        return (
          <li
            key={index}
            className={
              ((disabled || pages === 0) && "disabled") ||
              (page === index && "active")
            }
          >
            <Anchor onClick={handlePageClick(index)}>{index + 1}</Anchor>
          </li>
        );
      })}
      <li
        className={
          (disabled || page === pages - 1 || pages === 0) && "disabled"
        }
      >
        <Anchor onClick={handlePageClick(page * 1 + 1)}>
          <FontAwesomeIcon name="angle-right" />
        </Anchor>
      </li>
      <li
        className={
          (disabled || page === pages - 1 || pages === 0) && "disabled"
        }
      >
        <Anchor onClick={handlePageClick(pages * 1 - 1)}>
          <FontAwesomeIcon name="angle-double-right" />
        </Anchor>
      </li>
    </ul>
  );
}

Pagination.defaultProps = {
  className: "",
};
